/**
 * Sign out — URL `/sign-out` (site root).
 */

import { useEffect } from 'react'
import { useRouter, type Href } from 'expo-router'
import { useSupabaseAuth } from '../src/shared/contexts/SupabaseAuthContext'
import { JoinFlowLoadingScreen } from '../src/join/components/JoinFlowLoadingScreen'
import { PUBLIC_WELCOME_PATH } from '../src/signIn/constants/publicAuthRoutes.constants'

export default function SignOutScreen() {
  const { signOut } = useSupabaseAuth()
  const router = useRouter()

  useEffect(() => {
    const doSignOut = async () => {
      try {
        await signOut()
      } finally {
        // Land on the guest-first Welcome front door, not the sign-in form (guest-first AC-4b).
        router.replace(PUBLIC_WELCOME_PATH as Href)
      }
    }
    void doSignOut()
  }, [signOut, router])

  return <JoinFlowLoadingScreen message="Signing out…" />
}
